module.exports = __webpack_public_path__ + "img/White_Space_Invader.42424cef.gif";